<template>
  <v-row no-gutters align="center" justify="center">
    <v-col v-for="item in filteredRouteState" :key="item.postfix" md="1" cols="1" class="px-2 mx-1 cell_width">
      <div class="text-center">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="pointer" left :color="item.color" v-on="on">{{ item.icon }}</v-icon>
          </template>
          <span>{{ $vuetify.lang.t(item.title) }}</span>
        </v-tooltip>
        <span class="subtitle-1">
            <template
              v-if="
                'additionalStatisticsField' in item &&
                additionalStatistics[`_${item.additionalStatisticsField}`] !== null &&
                additionalStatistics[item.additionalStatisticsField] !== ''">
              <div class="text-center" v-if="additionalStatistics[`_${item.additionalStatisticsField}`] > 0">
                <span v-if="!debug">{{ additionalStatistics[`${item.additionalStatisticsField}Detailed`] }}</span>
                <span v-else>{{ additionalStatistics[`_${item.additionalStatisticsField}`] }}</span>
              </div>
            </template>
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'criticalStatisticsFilterValues',
  props: {
    routeState: Array,
    additionalStatistics: Object,
    debug: Boolean
  },
  computed: {
    filteredRouteState () {
      return this.routeState.filter(item => this.additionalStatistics[`_${item.additionalStatisticsField}`] > 0)
    }
  }
}
</script>

<style scoped>
  .cell_width {
    min-width: 70px;
  }
</style>
